import * as Observe from 'src/util/observe';
import * as StateTypes from 'src/state/types';

export const BusinessManagerValue = Observe.Value<null | StateTypes.BusinessManagerType>(null);
